module.exports = __webpack_public_path__ + "static/media/confirm-user-selected.e838aa6e.svg";